<app-layout>
  <app-voltar route="listagem/empresa" />
  <div class="main">
    <div class="header-table">
      <app-titulo>Empresas</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Ordem de Serviço</div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getOrdemServico()">
            <div class="table-filters">
              <app-input
                type="datetime-local"
                label="Data Início"
                placeholder="Digite aqui"
                name="DT_INIC"
                formControlName="DT_INIC"
                width="100%"></app-input>
              <app-input
                type="datetime-local"
                label="Data Final"
                placeholder="Digite aqui"
                name="DT_FIM"
                formControlName="DT_FIM"
                width="100%"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_INIC"
        formControlName="DT_INIC"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Final"
        placeholder="Digite aqui"
        name="DT_FIM"
        formControlName="DT_FIM"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
